export default __webpack_public_path__ + "static/media/Servier_preloader.0005bcbd.png";